import '../fit-spinner/fit-spinner';

import { LitElement, html } from 'lit';

class FitAjaxMore extends LitElement {
  render() {
    return html`
    <style>
      :host {
        display: block;
        position: relative;
        margin: 0;
      }

      #content {
        margin: 0 auto;
        max-width: 63.75rem;
        opacity: 1;
        transition: opacity .2s ease-in-out;
      }

      #content[loading] {
        opacity: .2;
        pointer-events: none;
      }

      #message {
        position: absolute;
        top: calc(50% - 2rem);
        left: calc(50% - 6rem);
      }

      .message-box {
        position: relative;
        padding: .5rem;
        width: 16rem;
        text-align: center;
        background: #fff;
        box-shadow: var(--font-accent-color) 0px 0px 5px 0px;
      }

      .message-box p {
        margin: 0 0 .5rem;
        font-size: 1rem;
        font-weight: 400;
        color: var(--secondary-color);
      }
    </style>

    <div id="content" ?loading="${this.loading}">
      <slot @click="${(e) => this._onMoreClick(e)}"></slot>
    </div>

    <div id="message" ?hidden="${!this.loading}">
      <div class="message-box">
        <p>${this['label-loading']}</p>
        <fit-spinner spinner-color="var(--google-blue-500)" spinner-size="24"></fit-spinner>
      </div>
    </div>`;
  }

  static get is() {
    return 'fit-ajax-more';
  }

  static get properties() {
    return {
      'label-loading': {
        type: String,
      },

      loading: {
        type: Boolean,
      },

      src: {
        type: String,
        reflect: true,
      },

      'insertion-point': {
        type: String,
      },
    };
  }

  _onMoreClick(event) {
    this.loading = true;

    fetch(this.src)
      .then((response) => {
        response.text().then((responseData) => {
          this._handleResponse(responseData);
        });
      })
      .catch((err) => {
        console.error('Error fetching more data. Error: ', err);
        this.loading = false;
      });
  }

  _handleResponse(responseData) {
    const insertionPoint = document.querySelector(this['insertion-point']);
    if (insertionPoint) {
      insertionPoint.insertAdjacentHTML('afterend', responseData);
      insertionPoint.remove();
    }
    this.loading = false;
  }
}

customElements.define(FitAjaxMore.is, FitAjaxMore);
